import $axios from "@/api";

const state = () => ({
    datas: {
        tracking_outlet_active:[]
    },
    filters: {
        ids_tim:[],
        ids_brand:[],
        ids_principal:[],
        ids_supervisor:[],
        start_week:1,
        start_year:2023,
        end_week:2,
        end_year:2023,
    },
    modal:{
        isOpen: false,
        backdrop: false,
        dismiss: true
    },
    form:{
        isLoading: false,
        colspan:0
    }
})

const mutations = {
    SET_DATAS(state, payload){
        state.datas[payload.target] = payload.data
    },
    setModal(state){
        const condition = !state.modal.isOpen
        if(condition){
            state.modal.backdrop = condition 
            setTimeout(() => {
                state.modal.isOpen = condition;
            }, 100);
        }else{
            state.modal.isOpen = condition 
            setTimeout(() => {
                state.modal.backdrop = condition;
            }, 100);
        }
    }
}

const actions = {
    async getTrackingOutletActive({state, commit}){
        try {
            state.form.isLoading = true
            const response = await $axios.get('/report/tracking/outlet-active',{params:state.filters})
            commit('SET_DATAS',{target:'tracking_outlet_active' ,data:response.data.data})
            state.form.colspan = Object.keys(response.data.data[0].detail_tracking).length + 5
            state.form.isLoading = false
        } catch (error) {
            console.log(error)
        }
    },
    isModal({commit}){
        commit('setModal')
    },
}

export default {
    namespaced: true,
    mutations,
    actions,
    state,
}